import $ from "jquery";

import { sessionFetch } from 'app/utils/sessionFetch';

import _ from "js/underscore-mixins";

/**
 *
 */
// TODO: Account for the fact that most of this file will be deleted when Todd removes contest code
window.CURALATE = window.CURALATE || {};
window.CURALATE.misc = window.CURALATE.misc || {};
window.CURALATE.modal = window.CURALATE.modal || {};
window.CURALATE.popover = window.CURALATE.popover || {};

/**
 * We use window.location.href to refresh the page instead of window.location.reload()
 * as the latter will resend POST data which can have unintended consequences.
 *
 * NOTE: As window.location.href will not work if there is a fragment in
 * the URL the entire fragment is removed before reloading.
 */
CURALATE.refreshPage = function() {
    window.location.href = window.location.href.split('#')[0];
};

/**
 * Hooks jquery AJAX requests to ensure that we are never mixing requests between clients. This can happen for example
 * if the user has more than one tab opened, switches the client on one tab, then goes back to another tab and invokes an AJAX request.
 */
(function() {
    function getClientIdFromCookie() {
        var matched = document.cookie.match(/crl8.clntid=.[^;]*/);
        if (matched){
            var cookie = matched[0].split('=');
            return parseInt(cookie[1], 10);
        }

        return null;
    }

    var pageLoadClientId = getClientIdFromCookie();

    $(document).ajaxSend(function(e, xhr) {
        var currentClientId = getClientIdFromCookie();
        if (pageLoadClientId !== currentClientId) {
            CURALATE.refreshPage();
            xhr.abort();
        }
    });
})();


/**
 * Methods that extend existing javascript classes
 */
if (typeof String.prototype.contains !== 'function') {
    String.prototype.contains = function(str, startIndex) {
        return ''.indexOf.call(this, str, startIndex) !== -1;
    };
}

CURALATE.misc.Components = (function() {

    var getSwitcherSetCallback = function() {
        return window.crl8.clientSwitcherSetClientCallback || angular.noop;
    };

    return {
        onBrandChanged: function() {
            getSwitcherSetCallback()();
            CURALATE.refreshPage();
        },
        onGroupChanged: function() {
            getSwitcherSetCallback()();
            CURALATE.refreshPage();
        },
        changeClient: function(clientId) {
            sessionFetch('/api/clients', {
                method: 'POST',
                body: JSON.stringify({ id: clientId }),
            }).then(CURALATE.misc.Components.onBrandChanged);
        },
        changeGroup: function(groupSelector) {
            sessionFetch('/api/groups', {
                method: 'POST',
                body: JSON.stringify({ id: groupSelector.value }),
            }).then(CURALATE.misc.Components.onGroupChanged);
        },
    };
})();

// This is only here so datatables and other non angular
// components have a way to react to date range changes
CURALATE.datepicker = {
    onChangeCallbacks: []
};

CURALATE.misc.renderToReadableNumber = function(o, val) {
    if (!_.isNumber(val)) {
        return val;
    } else {
        var units = ['', 'K', 'M', 'B', 'T'],
            unit = units.length - 1,
            kilo = 1000,
            decimals = 1, // decimal places to render
            fVal = parseFloat(Math.abs(val)), // Normalize number for formatting
            sign = val < 0 ? '-' : '', // Check if the original value is < 0
            suffix , intPart, decimalString, humanized;

        if (fVal < 10000) {
            return sign + fVal.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Display all digits if we're in the thousands
        } else if (fVal < 100000) {
            fVal = Math.round(fVal / 100) * 100;
        } else if (fVal < 1000000)  {
            fVal = Math.round(fVal / 1000) * 1000;
        } else if (fVal < 1000000000) {
            fVal = Math.round(fVal / 100000) * 100000;
        } else {
            fVal = Math.round(fVal / 1000000000) * 1000000000;
        }

        for (var i = 0; i < units.length; i++) {
            if (fVal < Math.pow(kilo, i + 1)) {
                unit = i;
                break;
            }
        }

        humanized = fVal / Math.pow(kilo, unit);
        suffix = units[unit] ? units[unit] : '';

        // Grab the integer part of the number
        intPart = parseInt(humanized.toFixed(decimals), 10) + '';

        // If the int part of our formatted result is 3 digits, make sure we round the humanized result again
        // because we aren't going to display a decimal point to contextualize our initial rounding
        if (intPart.length === 3) {
            intPart = parseInt(Math.round(humanized).toFixed(decimals), 10) + '';
        }

        // Format the decimals, but only if the integer part's length is < 3
        if (decimals && intPart.length !== 3) {
            decimalString = '.' + Math.abs(humanized - intPart).toFixed(decimals).slice(2);
        } else {
            decimalString = '';
        }
        return sign + intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + decimalString + suffix;
    }
};

CURALATE.misc.renderToReadableDecimal = function(o, val) {
    if (_.isNumber(val) && val < 1000) {
        return val.toFixed(1);
    } else {
        return CURALATE.misc.renderToReadableNumber(o, val);
    }
};

CURALATE.misc.DATE_RANGE_CONSTANTS = {};
